import React from 'react';

interface CountryStat {
    flag: string;
    name: string;
    networks: number;
    versions: number;
    active: number;
    inProgress: number;
    archived: number;
}

const COUNTRY_STATS: CountryStat[] = [
    { flag: '🇫🇷', name: 'France',    networks: 9, versions: 27, active: 6, inProgress: 1, archived: 2 },
    { flag: '🇪🇸', name: 'Espagne',   networks: 5, versions: 14, active: 3, inProgress: 1, archived: 1 },
    { flag: '🇮🇹', name: 'Italie',    networks: 4, versions: 12, active: 3, inProgress: 0, archived: 1 },
    { flag: '🇩🇪', name: 'Allemagne', networks: 3, versions:  9, active: 2, inProgress: 0, archived: 1 },
    { flag: '🇵🇱', name: 'Pologne',   networks: 2, versions:  5, active: 2, inProgress: 0, archived: 0 },
];

const TYPE_DIST = [
    { label: 'Eau chaude',  count: 14, color: '#E53935' },
    { label: 'Eau froide',  count:  5, color: '#1E88E5' },
    { label: 'Vapeur',      count:  3, color: '#FB8C00' },
    { label: 'Condensat',   count:  1, color: '#43A047' },
];

const TOP_CITIES = [
    { city: 'Paris',   flag: '🇫🇷', networks: 3, versions: 9 },
    { city: 'Lyon',    flag: '🇫🇷', networks: 2, versions: 6 },
    { city: 'Madrid',  flag: '🇪🇸', networks: 2, versions: 5 },
    { city: 'Berlin',  flag: '🇩🇪', networks: 2, versions: 5 },
    { city: 'Milan',   flag: '🇮🇹', networks: 2, versions: 4 },
];

const TOTAL_NETWORKS = COUNTRY_STATS.reduce((s, c) => s + c.networks, 0);
const TOTAL_VERSIONS = COUNTRY_STATS.reduce((s, c) => s + c.versions, 0);
const TOTAL_ACTIVE   = COUNTRY_STATS.reduce((s, c) => s + c.active, 0);
const TOTAL_PROGRESS = COUNTRY_STATS.reduce((s, c) => s + c.inProgress, 0);
const TOTAL_ARCHIVED = COUNTRY_STATS.reduce((s, c) => s + c.archived, 0);
const TOTAL_TYPE     = TYPE_DIST.reduce((s, t) => s + t.count, 0);

const GLOBAL_KPIS = [
    { label: 'Réseaux référentiels', value: TOTAL_NETWORKS, icon: 'account_tree', color: 'var(--nj-semantic-color-text-brand-primary-default)' },
    { label: 'Total versions',        value: TOTAL_VERSIONS, icon: 'layers',       color: 'var(--nj-core-color-grey-600)' },
    { label: 'Actifs',                value: TOTAL_ACTIVE,   icon: 'check_circle', color: '#2E7D32' },
    { label: 'En cours',              value: TOTAL_PROGRESS, icon: 'pending',      color: '#F57C00' },
    { label: 'Archivés',              value: TOTAL_ARCHIVED, icon: 'archive',      color: 'var(--nj-semantic-color-text-tertiary-default)' },
];

const cardStyle: React.CSSProperties = {
    background: 'var(--nj-semantic-color-background-neutral-primary-default)',
    borderRadius: 8,
    border: '1px solid var(--nj-semantic-color-border-neutral-minimal-default)',
    padding: '16px 20px',
};

const sectionTitleStyle: React.CSSProperties = {
    fontSize: 11,
    fontWeight: 700,
    color: 'var(--nj-semantic-color-text-secondary-default)',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBottom: 12,
};

export default function StatsTab() {
    return (
        <div style={{ padding: '24px', overflowY: 'auto', height: '100%', background: 'var(--nj-semantic-color-background-neutral-secondary-default)' }}>

            {/* ── Global KPIs ── */}
            <section style={{ marginBottom: 24 }}>
                <p style={sectionTitleStyle}>Vue globale</p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12 }}>
                    {GLOBAL_KPIS.map(kpi => (
                        <div key={kpi.label} style={{ ...cardStyle, display: 'flex', flexDirection: 'column', gap: 8 }}>
                            <span className="material-icons" style={{ fontSize: 20, color: kpi.color }}>{kpi.icon}</span>
                            <span style={{ fontSize: 28, fontWeight: 700, color: kpi.color, lineHeight: 1 }}>{kpi.value}</span>
                            <span style={{ fontSize: 12, color: 'var(--nj-semantic-color-text-secondary-default)', lineHeight: 1.4 }}>{kpi.label}</span>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── Par pays ── */}
            <section style={{ marginBottom: 24 }}>
                <p style={sectionTitleStyle}>Par pays</p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12 }}>
                    {COUNTRY_STATS.map(c => {
                        const total = c.active + c.inProgress + c.archived;
                        return (
                            <div key={c.name} style={{ ...cardStyle, padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <span style={{ fontSize: 22 }}>{c.flag}</span>
                                    <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--nj-semantic-color-text-primary-default)' }}>{c.name}</span>
                                </div>
                                <div style={{ display: 'flex', gap: 20 }}>
                                    <div>
                                        <div style={{ fontSize: 24, fontWeight: 700, color: 'var(--nj-semantic-color-text-brand-primary-default)', lineHeight: 1 }}>{c.networks}</div>
                                        <div style={{ fontSize: 11, color: 'var(--nj-semantic-color-text-secondary-default)', marginTop: 2 }}>réseaux</div>
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 24, fontWeight: 700, color: 'var(--nj-semantic-color-text-tertiary-default)', lineHeight: 1 }}>{c.versions}</div>
                                        <div style={{ fontSize: 11, color: 'var(--nj-semantic-color-text-secondary-default)', marginTop: 2 }}>versions</div>
                                    </div>
                                </div>
                                {/* Statut mini-bar */}
                                <div>
                                    <div style={{ display: 'flex', borderRadius: 4, overflow: 'hidden', height: 6 }}>
                                        {c.active     > 0 && <div style={{ flex: c.active,     background: '#2E7D32' }} />}
                                        {c.inProgress > 0 && <div style={{ flex: c.inProgress, background: '#F57C00' }} />}
                                        {c.archived   > 0 && <div style={{ flex: c.archived,   background: '#BDBDBD' }} />}
                                        {total === 0       && <div style={{ flex: 1,             background: 'var(--nj-semantic-color-border-neutral-minimal-default)' }} />}
                                    </div>
                                    <div style={{ display: 'flex', gap: 8, marginTop: 5, flexWrap: 'wrap' }}>
                                        {c.active     > 0 && <span style={{ fontSize: 11, color: '#2E7D32' }}>● {c.active} actif{c.active > 1 ? 's' : ''}</span>}
                                        {c.inProgress > 0 && <span style={{ fontSize: 11, color: '#F57C00' }}>● {c.inProgress} en cours</span>}
                                        {c.archived   > 0 && <span style={{ fontSize: 11, color: '#9E9E9E' }}>● {c.archived} archivé{c.archived > 1 ? 's' : ''}</span>}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </section>

            {/* ── Bottom row: Type + Top villes ── */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>

                {/* Répartition par type */}
                <section style={cardStyle}>
                    <p style={sectionTitleStyle}>Répartition par type</p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                        {TYPE_DIST.map(t => {
                            const pct = Math.round(t.count / TOTAL_TYPE * 100);
                            return (
                                <div key={t.label}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <span style={{ width: 10, height: 10, borderRadius: '50%', background: t.color, display: 'inline-block', flexShrink: 0 }} />
                                            <span style={{ fontSize: 13, color: 'var(--nj-semantic-color-text-primary-default)' }}>{t.label}</span>
                                        </div>
                                        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--nj-semantic-color-text-secondary-default)' }}>
                                            {t.count} réseau{t.count > 1 ? 'x' : ''} — {pct} %
                                        </span>
                                    </div>
                                    <div style={{ height: 8, background: 'var(--nj-semantic-color-background-neutral-tertiary-translucent-default)', borderRadius: 4, overflow: 'hidden' }}>
                                        <div style={{ height: '100%', width: `${pct}%`, background: t.color, borderRadius: 4, transition: 'width 400ms ease' }} />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </section>

                {/* Top villes */}
                <section style={cardStyle}>
                    <p style={sectionTitleStyle}>Top villes</p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                        {TOP_CITIES.map((c, i) => (
                            <div key={c.city} style={{
                                display: 'flex', alignItems: 'center', gap: 10,
                                padding: '10px 0',
                                borderBottom: i < TOP_CITIES.length - 1 ? '1px solid var(--nj-semantic-color-border-neutral-minimal-default)' : 'none',
                            }}>
                                <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--nj-semantic-color-text-tertiary-default)', width: 18, textAlign: 'right', flexShrink: 0 }}>
                                    {i + 1}
                                </span>
                                <span style={{ fontSize: 18, flexShrink: 0 }}>{c.flag}</span>
                                <span style={{ fontSize: 13, flex: 1, color: 'var(--nj-semantic-color-text-primary-default)', fontWeight: 500 }}>{c.city}</span>
                                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                                    <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--nj-semantic-color-text-brand-primary-default)' }}>
                                        {c.networks} rés.
                                    </span>
                                    <span style={{ fontSize: 12, color: 'var(--nj-semantic-color-text-secondary-default)' }}>
                                        {c.versions} ver.
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>

        </div>
    );
}
